import React from 'react';
import styles from './NoAccess.module.css';

const NoAccess: React.FC = () => (
  <div className={styles.noAccess}>
    <h1 className={styles.title}>Access denied</h1>
    <p className={styles.message}>
      Your account does not have permission to view this page. Contact an administrator if you need access.
    </p>
  </div>
);

export default NoAccess;
